export enum AddressType {
  Tmc = 'TMC',
  TmcEurolog = 'TMC_EUROLOG',
  NonTmc = 'NON_TMC',
  Sap = 'SAP',
  Web = 'WEB',
  Unknown = 'UNKNOWN',
}

export enum ExportAddress {
  ExportToExcel = 'exportToExcel',
  ExportToGateAddress = 'exportToGateAddress',
}
